import React, { useEffect } from 'react';
import { useCancelationPolicies } from './hooks/CancelationPolicies.hook';
import CancelationPoliciesView from './views/CancelationPoliciesView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const CancelationPoliciesController = () => {
  const { isLoading, spacesData } = useCancelationPolicies();
  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return <CancelationPoliciesView spacesData={spacesData} />;
  }
};

export default CancelationPoliciesController;
